module.exports = __webpack_public_path__ + "uz.svg?519585c39d3ee3a0c8b8cd647c5c255d";